import React, { useState, useRef } from "react";
import domtoimage from "dom-to-image";
import style from "./PlacaCompleta.module.css";
import logo from '../../../Assets/sinFondo.png';
import ubicacion from '../../../Assets/ubicacion.png';
import grifo from '../../../Assets/agua-del-grifo.png';
import zona from '../../../Assets/zona.png';
import banera from '../../../Assets/banera.png';
import cama from '../../../Assets/cama-matrimonial.png';
import financiacion from '../../../Assets/ahorrar-dinero.png';
import cocina from '../../../Assets/estufa-de-cocina.png';
import nuevoLogo from '../../../Assets/nuevoLogo.png'

const PlacaCompleta = () => {
  const [images, setImages] = useState({
    mainImage: null,
    secondaryImage1: null,
    secondaryImage2: null,
    secondaryImage3: null,
  });
  const [title, setTitle] = useState("EN VENTA");
  const [price, setPrice] = useState("U$D 230.000");
  const [metros, setMetros] = useState("100 M2");
  const [location, setLocation] = useState("General Paz, Godoy Cruz");
  const [services, setServices] = useState("💡 💧 🔥");
  const [bathrooms, setBathrooms] = useState("2 Baños");
  const [rooms, setRooms] = useState("3 Habitaciones");
  const [kitchen, setKitchen] = useState("Cocina equipada");
  const [financing, setFinancing] = useState("Sí, apta financiación");
  const [type, setType] = useState("DEPARTAMENTO");

  const placaRef = useRef(null);

  const handleImageChange = (e, imageType) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        setImages((prev) => ({ ...prev, [imageType]: event.target.result }));
      };
      reader.readAsDataURL(file);
    }
  };
  
  const downloadPlaca = () => {
    const element = placaRef.current;
  
    // Guardar los estilos originales
    const originalStyle = element.getAttribute("style");
  
    // Aplicar estilos temporales para forzar un tamaño fijo
    element.setAttribute(
      "style",
      `
        width: 1080px;
        height: 1080px;
        transform: none;
        transform-origin: top left;
        position: relative;
      `
    );
  
    // Generar la imagen
    domtoimage
      .toPng(element)
      .then((dataUrl) => {
        const link = document.createElement("a");
        link.download = "placa_publicitaria.png";
        link.href = dataUrl;
        link.click();
      })
      .catch((error) => {
        console.error("Error al generar la imagen:", error);
      })
      .finally(() => {
        // Restaurar los estilos originales
        if (originalStyle) {
          element.setAttribute("style", originalStyle);
        } else {
          element.removeAttribute("style");
        }
      });
  };

  return (
    <div className={style.container}>
      <div className={style.editControls}>
        <label>
          Tipo de inmueble:
          <input
            type="text"
            value={type}
            onChange={(e) => setType(e.target.value)}
            className={style.input}
          />
        </label>
        <label>
          Título:
          <input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            className={style.input}
          />
        </label>
        <label>
          Precio:
          <input
            type="text"
            value={price}
            onChange={(e) => setPrice(e.target.value)}
            className={style.input}
          />
        </label>
        <label>
          Ubicación:
          <input
            type="text"
            value={location}
            onChange={(e) => setLocation(e.target.value)}
            className={style.input}
          />
        </label>
        <label>
          Metraje:
          <input
            type="text"
            value={metros}
            onChange={(e) => setMetros(e.target.value)}
            className={style.input}
          />
        </label>
        <label>
          Baños:
          <input
            type="text"
            value={bathrooms}
            onChange={(e) => setBathrooms(e.target.value)}
            className={style.input}
          />
        </label>
        <label>
          Habitaciones:
          <input
            type="text"
            value={rooms}
            onChange={(e) => setRooms(e.target.value)}
            className={style.input}
          />
        </label>
        <label>
          Cocina:
          <input
            type="text"
            value={kitchen}
            onChange={(e) => setKitchen(e.target.value)}
            className={style.input}
          />
        </label>
        <label>
          Apta Financiación:
          <input
            type="text"
            value={financing}
            onChange={(e) => setFinancing(e.target.value)}
            className={style.input}
          />
        </label>
      </div>

      <div ref={placaRef} className={style.placa}>
        <div className={style.secondPlaca}>
          <div className={style.content}>
            <div
              className={style.mainImage}
              onClick={() => document.getElementById('fileInputMain1').click()}
            >
              {images.mainImage ? (
                <img src={images.mainImage} alt="Principal" />
              ) : (
                <p>Cargar Imagen Principal</p>
              )}
              <input
                type="file"
                id="fileInputMain1"
                accept="image/*"
                onChange={(e) => handleImageChange(e, "mainImage")}
                hidden
              />
            </div>

            <div className={style.secondaryImages}>
              <div
                className={style.secondaryImage}
                onClick={() => document.getElementById('fileInput1').click()}
              >
                {images.secondaryImage1 ? (
                  <img src={images.secondaryImage1} alt="Secundaria 1" />
                ) : (
                  <p>Cargar Imagen 1</p>
                )}
                <input
                  type="file"
                  id="fileInput1"
                  accept="image/*"
                  onChange={(e) => handleImageChange(e, "secondaryImage1")}
                  hidden
                />
              </div>

              <div
                className={style.secondaryImage2}
                onClick={() => document.getElementById('fileInput2').click()}
              >
                {images.secondaryImage2 ? (
                  <img src={images.secondaryImage2} alt="Secundaria 2" />
                ) : (
                  <p>Cargar Imagen 2</p>
                )}
                <input
                  type="file"
                  id="fileInput2"
                  accept="image/*"
                  onChange={(e) => handleImageChange(e, "secondaryImage2")}
                  hidden
                />
              </div>

              <div
                className={style.secondaryImage3}
                onClick={() => document.getElementById('fileInput3').click()}
              >
                {images.secondaryImage3 ? (
                  <img src={images.secondaryImage3} alt="Secundaria 3" />
                ) : (
                  <p>Cargar Imagen 3</p>
                )}
                <input
                  type="file"
                  id="fileInput3"
                  accept="image/*"
                  onChange={(e) => handleImageChange(e, "secondaryImage3")}
                  hidden
                />
              </div>
            </div>
          </div>
          <h1 className={style.type}>{type}</h1>
          <h1 className={style.title}>{title}</h1>
          <h3 className={style.detalles}>DETALLES</h3>
          <div className={style.logo}>
            <img src={nuevoLogo} alt="Logo" />
          </div>

          <div className={style.info}>
            <div className={style.infoLeft}>
              {metros && (
                <div className={`${style.containerUbicacion} left`}>
                  <img src={zona} alt="" />
                  <p className={style.location}>{metros}</p>
                </div>
              )}
              {bathrooms && (
                <div className={`${style.containerUbicacion} left`}>
                  <img src={banera} alt="" />
                  <p className={style.location}>{bathrooms}</p>
                </div>
              )}
              {location && (
                <div className={`${style.containerUbicacion} left`}>
                  <img src={ubicacion} alt="" />
                  <p className={style.locationTitle}>{location}</p>
                </div>
              )}
            </div>

            <div className={style.infoRight}>
              {rooms && (
                <div className={`${style.containerServicios} right`}>
                  <img src={cama} alt="" />
                  <p className={style.location}>{rooms}</p>
                </div>
              )}

              {financing && (
                <div className={`${style.containerServicios} right`}>
                  <img src={financiacion} alt="" />
                  <p className={style.location}>{financing}</p>
                </div>
              )}

              {kitchen && (
                <div className={`${style.containerServicios} right`}>
                  <img src={cocina} alt="" />
                  <p className={style.location}>{kitchen}</p>
                </div>
              )}
            </div>
          </div>

          <div className={style.price}>{price}</div>
          <div className={style.footer}>
            <p>www.byraices.com</p>
            <p>Julieta Garcia C.C.P.I.M Mat 2009</p>
          </div>
        </div>
      </div>

      <button onClick={downloadPlaca} className={style.downloadButton}>
        Descargar Placa
      </button>
    </div>
  );
};

export default PlacaCompleta;

